import { styled } from "@mui/material"

export const Container = styled("div")({
    height: "100%",
    position: "relative",
    width: "100%",
})